module.exports = __webpack_public_path__ + "img/visa_white.bc48deeb.svg";